import { useLockedFeatures } from '../../providers/LockedFeatures.provider';

export default function useSettingsLockState() {
  const lockedFeatures = useLockedFeatures();

  // Only the products the Account Portal's Branding page offers. Onboarding (Application Form) branding is
  // partner-only, so an account with just that flag would open onto a page with nothing to brand.
  const brandingLocked =
    !lockedFeatures.BrandingELinxEnabled &&
    !lockedFeatures.BrandingEmailEnabled &&
    !lockedFeatures.BrandingPortalEnabled;

  const elinxLocked = !lockedFeatures.PayLinkEnabled;
  const domainSetupLocked = !lockedFeatures.EmailDomainEnabled;

  return { brandingLocked, elinxLocked, domainSetupLocked };
}
